import { render, staticRenderFns } from "./empty.mpx?vue&type=template&id=7554cfec&scoped=true&component=true&componentId=empty06ad35b3"
import script from "./empty.mpx?vue&type=script&lang=js&component=true&componentId=empty06ad35b3"
export * from "./empty.mpx?vue&type=script&lang=js&component=true&componentId=empty06ad35b3"
import style0 from "./empty.mpx?vue&type=style&index=0&id=7554cfec&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m06ad35b3%22%7D&component=true&componentId=empty06ad35b3"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7554cfec",
  null
  
)

export default component.exports